import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

export default function MatchMarket({match, skipCommission = false}) {
    const { t } = useTranslation()
    const { commission } = useSelector(state => state.commissions)

    const getMediaUrl = (src, fallback) => {
        if (!src || typeof src !== 'string') return fallback
        let trimmed = src.trim()
        if (!trimmed) return fallback
        if (trimmed.startsWith('data:')) return trimmed

        const apiBase = process.env.REACT_APP_DB_ADDRESS?.replace(/\/+$/, '')
        if (apiBase && /^https?:\/\/localhost:\d+/i.test(trimmed)) {
            trimmed = trimmed.replace(/^https?:\/\/localhost:\d+/i, apiBase)
        }

        return encodeURI(trimmed)
    }

    const hostBadgeUrl = getMediaUrl(match?.hostBadge, '/images/bannerclub.jpg')
    const visitorBadgeUrl = getMediaUrl(match?.visitorBadge, '/images/bannerclub.jpg')

    const calculatePrice = (price) => {
        if (typeof price !== 'number') {
            price = parseFloat(price)
        }

        if (!isNaN(price) && price > 0) {
            const ticketingCommission = skipCommission
                ? null
                : commission?.ticketing?.find(ticketing => price >= ticketing.lowPrice && price <= ticketing.highPrice)
            return parseFloat((Math.ceil((parseFloat(price) + parseFloat(price * (ticketingCommission?.percentage || 0) / 100) + parseFloat(ticketingCommission?.double || 0)) * 100) / 100).toFixed(2))
        } else {
            return 0.00
        }
    }

    return (
        <Card className="miniatura">
            <Link to={`/${t("url.marketplace.clubs")}/${match?.club?.url}/${t("url.marketplace.matches")}/${match?.url}`}>
                <Row className="justify-content-around my-2">
                    <Col xs={5}>
                        <div className="image" variant="top" style={{
                            backgroundImage: `url("${hostBadgeUrl}")`,
                            backgroundSize: 'contain',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat'
                        }}/>
                    </Col>
                    <Col xs={5}>
                        <div className="image" variant="top" style={{
                            backgroundImage: `url("${visitorBadgeUrl}")`,
                            backgroundSize: 'contain',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat'
                        }}/>
                    </Col>
                </Row>
            </Link>
            <Card.Body>
                <Card.Title>{match.host} - {match.visitor}</Card.Title>
                <Row className="mt-2">
                    <Col className="d-flex align-items-center">
                        <img src="/images/calendar.svg" alt="people" className="me-2"/>                    
                        {`${String(new Date(match.date).getDate()).padStart(2, '0')}/${String(new Date(match.date).getMonth() + 1).padStart(2, '0')}/${new Date(match.date).getFullYear()} ${match.hour}`}
                    </Col>
                </Row>
                <Row className="mt-4">
                    <Col className="d-flex align-items-center justify-content-between flex-wrap">
                        <span className="price">
                            {match?.price !== 0
                                ? `${t("global.from")} ${calculatePrice(match?.price)}€`
                                : "Gratuita"}
                        </span>
                        <Link
                            to={`/${t("url.marketplace.clubs")}/${match?.club?.url}/${t("url.marketplace.matches")}/${match?.url}`}
                            className="btn btn-primary"
                        >
                            {t("matches.buy")}
                            <img src="/images/rignt-arrow.svg" alt="Continuar" className="ms-3"/>
                        </Link>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    )
}